module.exports = __webpack_public_path__ + "static/img/logo.b29cba5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/logo.svg
// module id = LsT+
// module chunks = 0